import TawkMessengerReact from '@tawk.to/tawk-messenger-react';
import { useRef } from 'react';

export function TawkTo({ user }) {
	const tawkMessengerRef = useRef();

	const tawkOnLoad = () => {
		if (user && user.ID && tawkMessengerRef?.current?.setAttributes) {
			tawkMessengerRef.current.setAttributes({
				name: user.Name,
				email: user.EmailID,
			});
		}
	};

	return (
		<TawkMessengerReact
			propertyId="691198ec7b17c419593f5abb"
			widgetId="1j9mbqn61"
			onLoad={tawkOnLoad}
			ref={tawkMessengerRef} />
	);
}
